(function () {
  "use strict";

  class PhosphateSupplementationCalculator extends HTMLElement {
    connectedCallback() {
      if (this.__phosphateSupplementationInitialized) return;
      this.__phosphateSupplementationInitialized = true;

      var root = this;

      var state={species:root.dataset.defaultSpecies==='cat'?'cat':'dog',unit:root.dataset.defaultUnit==='mmol'?'mmol':'mgdl',salt:root.dataset.defaultSalt==='na'?'na':'k'};
        var P_CONV=3.097;      // 1 mmol/L = 3.097 mg/dL
        var K_CAP=0.5;         // mEq/kg/hr
        var SALT={k:{po4:3,e:4.4,eName:'Potassium',ion:'K⁺',mono:'mEq K⁺'},
                  na:{po4:3,e:4.0,eName:'Sodium',ion:'Na⁺',mono:'mEq Na⁺'}};

        var $=function(id){return root.querySelector('#'+id)};

        // segmented controls
        function seg(groupId,key){
          var g=$(groupId);
          g.querySelectorAll('button[data-v]').forEach(function(b){
            b.addEventListener('click',function(){
              g.querySelectorAll('button').forEach(function(x){x.classList.remove('on')});
              b.classList.add('on');
              var old=state[key];
              state[key]=b.dataset.v;
              if(key==='unit') convertUnit(old,state.unit);
              calc();
            });
          });
        }
        seg('species','species'); seg('unit','unit');

        function convertUnit(from,to){
          var el=$('phos'); var v=parseFloat(el.value);
          if(isNaN(v))return;
          if(from==='mgdl'&&to==='mmol') el.value=(v/P_CONV).toFixed(2);
          else if(from==='mmol'&&to==='mgdl') el.value=(v*P_CONV).toFixed(1);
        }

        ['wt','phos','rate','dur','salt','kcl','bag','frate'].forEach(function(id){
          $(id).addEventListener('input',function(){
            if(id==='salt') state.salt=$('salt').value;
            calc();
          });
        });

        function fmt(n,d){ if(!isFinite(n)) return '—'; return n.toFixed(d===undefined?2:d); }

        function interpret(mgdl,species){
          // returns {cls,badge,badgeCls,lead,desc,ref}
          if(isNaN(mgdl)) return null;
          var mmol=mgdl/P_CONV;
          var both=fmt(mgdl,1)+' mg/dL · '+fmt(mmol,2)+' mmol/L';
          var ref = species==='cat'
            ? 'Feline reference ≈ 2.4–6.3 mg/dL (0.8–2.0 mmol/L). Cats are especially prone to phosphate-driven haemolysis.'
            : 'Canine reference ≈ 2.5–6.8 mg/dL (0.8–2.2 mmol/L); higher in growing dogs.';
          if(mgdl>=2.5) return {cls:'ok',badge:'Within range',badgeCls:'b-ok',ref:ref,
            lead:'Phosphorus '+both,
            desc:'At or above the lower reference limit. Routine supplementation not usually required — but in DKA on insulin, recheck in 6–12 h as it can fall fast.'};
          if(mgdl>=2.0) return {cls:'warn',badge:'Low-normal',badgeCls:'b-warn',ref:ref,
            lead:'Phosphorus '+both,
            desc:'Borderline. Supplement if symptomatic or receiving insulin for DKA; otherwise monitor closely and recheck.'};
          if(mgdl>=1.5) return {cls:'warn',badge:'Moderate hypophosphataemia',badgeCls:'b-warn',ref:ref,
            lead:'Phosphorus '+both,
            desc:'Supplement if there are clinical signs or ongoing insulin therapy. Begin at 0.03 mmol/kg/hr and recheck in 6 h.'};
          return {cls:'dang',badge:'Severe hypophosphataemia',badgeCls:'b-dang',ref:ref,
            lead:'Phosphorus '+both,
            desc:'Treat now. Risk of haemolysis, weakness and neurological signs'+(species==='cat'?' — cats can develop acute haemolytic anaemia':'')+'. Start a CRI and recheck phosphorus in 6 h.'};
        }

        function calc(){
          var wt=parseFloat($('wt').value);
          var rateInput=$('rate');
          var rate=parseFloat(rateInput.value);
          var rateMin=parseFloat(rateInput.min);
          var rateMax=parseFloat(rateInput.max);
          var rateProgress=((rate-rateMin)/(rateMax-rateMin))*100;
          rateInput.style.setProperty('--psc-range-progress',rateProgress+'%');
          var dur=parseFloat($('dur').value);
          var s=SALT[state.salt];
          $('rateOut').textContent=fmt(rate,3);

          // interpretation
          var phosRaw=parseFloat($('phos').value);
          var mgdl = state.unit==='mgdl'?phosRaw:phosRaw*P_CONV;
          var ip=interpret(mgdl,state.species);
          var ie=$('interp');
          if(ip){ ie.innerHTML='<div class="interp '+ip.cls+'"><span class="badge '+ip.badgeCls+'">'+ip.badge+
            '</span><div class="lead">'+ip.lead+'</div><div class="desc">'+ip.desc+'</div>'+
            '<div class="desc" style="margin-top:6px;opacity:.7;font-size:12px">'+ip.ref+'</div></div>'; }
          else ie.innerHTML='<div class="interp ok" style="background:#f7fafb;border-color:var(--psc-line)"><div class="desc">Enter a serum phosphorus value for automatic interpretation.</div></div>';

          if(isNaN(wt)||wt<=0||isNaN(rate)||isNaN(dur)||dur<=0){
            ['rHero','rMmolHr','rTotal','rSaltHr','rE'].forEach(function(id){$(id).textContent='—'});
            $('ktrack').style.display='none';
            $('bagOut').innerHTML='';
            $('alerts').innerHTML='';
            return;
          }

          var po4hr=rate*wt;                 // mmol/hr
          var total=po4hr*dur;               // mmol
          var saltHr=po4hr/s.po4;            // mL/hr
          var saltTot=total/s.po4;           // mL total
          var eHr=saltHr*s.e;                // mEq/hr
          var eRate=eHr/wt;                  // mEq/kg/hr

          $('rHero').innerHTML=fmt(saltTot,2)+' <span class="u">mL total</span>';
          $('rMmolHr').textContent=fmt(po4hr,2);
          $('rTotal').textContent=fmt(total,2);
          $('rSaltHr').textContent=fmt(saltHr,3);
          $('saltRateLbl').textContent=(state.salt==='k'?'K-phosphate':'Na-phosphate')+' rate';
          $('rE').textContent=fmt(eRate,3);
          $('eLbl').textContent=s.eName+' load';
          $('eU').textContent=s.mono+'/kg/hr';

          // potassium tracker (only meaningful for K salt)
          var kt=$('ktrack');
          if(state.salt==='k'){
            kt.style.display='block';
            var kcl=parseFloat($('kcl').value)||0;
            var kPhos=eRate;
            var kTot=kPhos+kcl;
            $('ktLbl').textContent='Potassium from phosphate';
            $('ktPhos').textContent=fmt(kPhos,3)+' mEq/kg/hr';
            $('ktKcl').textContent=fmt(kcl,3)+' mEq/kg/hr';
            $('ktTotal').textContent=fmt(kTot,3)+' mEq/kg/hr';
            var pct=Math.min(100,kTot/K_CAP*100);
            var bar=$('kbar');
            bar.style.width=pct+'%';
            bar.style.background = kTot>K_CAP?'var(--psc-dang)':(kTot>K_CAP*0.8?'var(--psc-warn)':'var(--psc-ok)');
          } else { kt.style.display='none'; }

          // bag mixing
          var bag=parseFloat($('bag').value)||0;
          var frate=parseFloat($('frate').value)||0;
          var bo=$('bagOut');
          if(bag>0&&frate>0){
            var conc=po4hr/frate;            // mmol/mL needed in bag
            var mlInBag=conc*bag/s.po4;      // mL salt into bag
            var hrsBag=bag/frate;
            bo.innerHTML='<div class="ktrack" style="margin-top:12px"><div class="row" style="font-weight:800;border:0"><span>Bag mixing</span><span></span></div>'+
              '<div class="row"><span>Add to '+fmt(bag,0)+' mL bag</span><span><b>'+fmt(mlInBag,2)+' mL</b> of '+(state.salt==='k'?'K-phosphate':'Na-phosphate')+'</span></div>'+
              '<div class="row"><span>Run at</span><span>'+fmt(frate,0)+' mL/hr → delivers '+fmt(po4hr,2)+' mmol/hr</span></div>'+
              '<div class="row"><span>This bag lasts</span><span>~'+fmt(hrsBag,1)+' h</span></div></div>';
          } else bo.innerHTML='';

          // alerts
          var al=[];
          if(state.salt==='k'){
            var kcl2=parseFloat($('kcl').value)||0;
            var kTot2=eRate+kcl2;
            if(kTot2>K_CAP) al.push({c:'d',t:'<b>Potassium rate exceeds 0.5 mEq/kg/hr.</b> Combined K⁺ from phosphate ('+fmt(eRate,3)+') and KCl ('+fmt(kcl2,3)+') = '+fmt(kTot2,3)+' mEq/kg/hr. Lower the phosphate rate, reduce KCl, or switch part of the load to sodium phosphate.'});
            else if(kTot2>K_CAP*0.8) al.push({c:'w',t:'Combined potassium is '+fmt(kTot2,3)+' mEq/kg/hr — approaching the 0.5 ceiling. Reduce KCl to make room for the phosphate potassium.'});
          }
          if(state.salt==='na') al.push({c:'w',t:'Sodium phosphate adds a sodium load — monitor for hypernatraemia, especially in cats and small patients.'});
          if(rate>0.06) al.push({c:'w',t:'Rate above 0.06 mmol/kg/hr is the aggressive end. Use only for severe/refractory hypophosphataemia with phosphorus rechecks every 6 h.'});
          al.push({c:'w',t:'<b>Do not add phosphate to calcium-containing fluids</b> (Hartmann\'s / LRS) — use 0.9% saline or another calcium-free carrier.'});
          var ah=$('alerts');
          ah.innerHTML=al.map(function(a){return '<div class="alert '+a.c+'"><span class="ic">'+(a.c==='d'?'!':'⚠')+'</span><span>'+a.t+'</span></div>';}).join('');
        }

        function resetAll(){
          $('wt').value=20;$('phos').value=state.unit==='mgdl'?1.2:(1.2/P_CONV).toFixed(2);
          $('rate').value=0.03;$('dur').value=6;$('salt').value='k';state.salt='k';
          $('kcl').value=0;$('bag').value=1000;$('frate').value=0;calc();
        };

        calc();
    }
  }

  if (!customElements.get("s-phosphate-supplementation-calculator")) {
    customElements.define(
      "s-phosphate-supplementation-calculator",
      PhosphateSupplementationCalculator
    );
  }
})();
